import { render, staticRenderFns } from "./CSCRegistryDlg.vue?vue&type=template&id=4771dc29&scoped=true&"
import script from "./CSCRegistryDlg.vue?vue&type=script&lang=js&"
export * from "./CSCRegistryDlg.vue?vue&type=script&lang=js&"
import style0 from "./CSCRegistryDlg.vue?vue&type=style&index=0&id=4771dc29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771dc29",
  null
  
)

export default component.exports